// import syles
import "./Login.css";

// import pacchetti
import { useState } from "react";
import { autenticazione } from "../../firebase/config";

// import hooks
import { useLogin } from "../../hooks/useLogin";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetMessage, setResetMessage] = useState(null);
  const [resetError, setResetError] = useState(null);
  const { login, error, isPending } = useLogin();

  const handleSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  const handleForgotPassword = async () => {
    setResetMessage(null);
    setResetError(null);

    if (!email) {
      setResetError("Inserisci la tua email per reimpostare la password");
      return;
    }

    try {
      await autenticazione.sendPasswordResetEmail(email);
      setResetMessage(
        "Ti abbiamo inviato un'email per reimpostare la password."
      );
    } catch (err) {
      setResetError(err.message);
    }
  };

  return (
    <div className="login-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>Accedi</h2>
        <label>
          <span>Email:</span>
          <input
            required
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </label>
        <label>
          <span>Password:</span>
          <input
            required
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </label>
        {!isPending && <button className="btn">Invia</button>}
        {isPending && (
          <button className="btn" disabled>
            Caricamento
          </button>
        )}
        {error && <div className="error">{error}</div>}

        <button
          type="button"
          className="forgot-link"
          onClick={handleForgotPassword}
        >
          Password dimenticata?
        </button>
        {resetMessage && <div className="success">{resetMessage}</div>}
        {resetError && <div className="error">{resetError}</div>}
      </form>
    </div>
  );
}
